export enum ColumnTypes {
    EVENT_CODE = 'Event Code',
    EVENT_SOURCE = 'Event Source',
    EVENT_TYPE = 'Event Type',
    ATTRIBUTE_DESCRIPTION = 'Attribute Description',
    DATA_TYPE = 'Data Type',
    POSSIBLE_VALUES = 'Possible Values',
    ATTRIBUTE_DEPRECATED = 'Attribute Deprecated',
    ATTRIBUTE_LAST_USAGE_DATE = 'Last Usage Date',
}

export const ColumnWidth = {
    [ColumnTypes.EVENT_CODE]: '15rem',
    [ColumnTypes.EVENT_SOURCE]: '12rem',
    [ColumnTypes.EVENT_TYPE]: '11rem',
    [ColumnTypes.ATTRIBUTE_DESCRIPTION]: '20%',
    [ColumnTypes.DATA_TYPE]: '12rem',
    [ColumnTypes.POSSIBLE_VALUES]: '20%',
    [ColumnTypes.ATTRIBUTE_DEPRECATED]: '10rem',
    [ColumnTypes.ATTRIBUTE_LAST_USAGE_DATE]: '11rem',
};
